import { ApolloError } from "@apollo/client/errors";

import { CreateOrUpdateEndorsementBlockReason } from "@covertree/agent-portal-graphql";

import { POLICY_CLOSE_EXPIRATION_ENDORSEMENT_MSG } from "@consts/index";

const BLOCK_REASON_MESSAGE: Record<
  CreateOrUpdateEndorsementBlockReason,
  string
> = {
  [CreateOrUpdateEndorsementBlockReason.ActiveEndorsement]:
    "This policy already has an endorsement in progress.",
  [CreateOrUpdateEndorsementBlockReason.ActiveRenewal]:
    "This policy has an active renewal and cannot be endorsed.",
  [CreateOrUpdateEndorsementBlockReason.NonRenewalIssued]:
    "A non-renewal has been issued for this policy, so it cannot be endorsed.",
  [CreateOrUpdateEndorsementBlockReason.PolicyCancelled]:
    "This policy is cancelled and cannot be endorsed.",
  [CreateOrUpdateEndorsementBlockReason.PolicyExpired]:
    "This policy has expired and cannot be endorsed.",
  [CreateOrUpdateEndorsementBlockReason.IneligibleRisk]:
    "These changes make the policy ineligible. Please review the coverages.",
  [CreateOrUpdateEndorsementBlockReason.EndorsementNotFound]:
    "This endorsement no longer exists. Please close and start again.",
  [CreateOrUpdateEndorsementBlockReason.SocotraRequestFailed]:
    "The policy system could not be reached. Please try again.",
  [CreateOrUpdateEndorsementBlockReason.PolicyCloseExpiration]:
    POLICY_CLOSE_EXPIRATION_ENDORSEMENT_MSG,
};

const isBlockReason = (
  value: unknown
): value is CreateOrUpdateEndorsementBlockReason =>
  typeof value === "string" && value in BLOCK_REASON_MESSAGE;

export const getEndorsementErrorMessage = (
  error: unknown,
  fallback = "Failed to save the endorsement. Please try again."
) => {
  if (isBlockReason(error)) return BLOCK_REASON_MESSAGE[error];

  if (error instanceof ApolloError) {
    return error.graphQLErrors[0]?.message ?? error.message ?? fallback;
  }

  // The slice unwraps - so GraphQLError also lands here.
  if (error instanceof Error && error.message) return error.message;

  return fallback;
};
